// AUTO-GENERATED by scripts/generate-analytics.cjs — DO NOT EDIT MANUALLY
// Source: tracking-data/*.csv — Generated: 2026-07-02T06:07:03.281Z
/* eslint-disable */
import type { EventName } from "./events";

export const PAGE_EVENTS = {
  "accessibility_alerts": {
    "add_alert_action_button": { events: ["place_alert_add_cta_activated"], elementType: "action_button" },
    "cancel_action_button": { events: ["resolve_alert_dialog_closed", "vote_alert_form_closed"], elementType: "action_button" },
    "close_action_button": { events: ["accessibility_alerts_closed"], elementType: "action_button" },
    "confirm_action_button": { events: ["alert_resolved"], elementType: "action_button" },
    "edit_pencil_action_button": { events: ["edit_alert_form_opened"], elementType: "action_button" },
    "filter_input_input_field": { events: ["list_filtered"], elementType: "input_field" },
    "live_alerts_tab": { events: ["place_alert_view_changed"], elementType: "tab" },
    "live_alerts_toggle_toggle": { events: ["place_notification_subscribed", "place_notification_unsubscribed"], elementType: "toggle" },
    "mapper_note_tab": { events: ["place_alert_view_changed"], elementType: "tab" },
    "no_action_button": { events: ["vote_alert_cta_activated"], elementType: "action_button" },
    "no_resolve_action_button": { events: ["resolve_alert_dialog_opened"], elementType: "action_button" },
    "not_sure_action_button": { events: ["vote_alert_cta_activated"], elementType: "action_button" },
    "notes_tab": { events: ["place_alert_view_changed"], elementType: "tab" },
    "page_view_page": { events: ["accessibility_alerts_viewed", "vote_alert_form_opened"], elementType: "page" },
    "save_action_button": { events: ["alert_voted"], elementType: "action_button" },
    "sort_dropdown_sort": { events: ["sort_changed"], elementType: "sort" },
    "yes_action_button": { events: ["vote_alert_cta_activated"], elementType: "action_button" },
  },
  "accessibility_guide": {
    "about_tab": { events: ["place_info_view_changed"], elementType: "tab" },
    "accessibility_features_control_button": { events: ["filter_opened"], elementType: "control_button" },
    "accessibility_tab": { events: ["place_info_view_changed"], elementType: "tab" },
    "alerts_tab": { events: ["place_info_view_changed"], elementType: "tab" },
    "back_action_button": { events: ["place_viewed"], elementType: "action_button" },
    "close_action_button": { events: ["nav_tree_closed"], elementType: "action_button" },
    "experiences_tab": { events: ["place_info_view_changed"], elementType: "tab" },
    "flag_action_button": { events: ["alert_flag_cta_activated"], elementType: "action_button" },
    "floor_control_button": { events: ["filter_opened"], elementType: "control_button" },
    "live_alerts_menu_list": { events: ["place_alert_view_changed"], elementType: "menu_list" },
    "nav_tree_expand_action_button": { events: ["nav_tree_viewed"], elementType: "action_button" },
    "notes_menu_list": { events: ["place_alert_view_changed"], elementType: "menu_list" },
    "page_view_page": { events: ["accessibility_guide_viewed"], elementType: "page" },
    "photo_target_area": { events: ["photo_lightbox_opened"], elementType: "target_area" },
    "photos_tab": { events: ["place_info_view_changed"], elementType: "tab" },
    "search_bar_input_field": { events: ["list_filtered"], elementType: "input_field" },
    "search_label_input_field": { events: ["space_search_performed"], elementType: "input_field" },
    "sort_dropdown_sort": { events: ["sort_changed"], elementType: "sort" },
    "space_card": { events: ["place_space_viewed"], elementType: "card" },
    "space_card_photo_carousel_target_area": { events: ["photo_lightbox_opened"], elementType: "target_area" },
    "space_item_menu_list": { events: ["place_space_viewed"], elementType: "menu_list" },
  },
  "accessibility_profile_form": {
    "close_action_button": { events: ["accessibility_profile_form_closed"], elementType: "action_button" },
    "page_view_page": { events: ["accessibility_profile_form_opened"], elementType: "page" },
    "update_profile_action_button": { events: ["accessibility_profile_updated"], elementType: "action_button" },
  },
  "activity": {
    "activity_type_filter_action_button": { events: ["activity_view_changed"], elementType: "action_button" },
    "alerts_tab": { events: ["activity_view_changed"], elementType: "tab" },
    "all_activity_tab": { events: ["activity_view_changed"], elementType: "tab" },
    "date_filter_action_button": { events: ["activity_filtered", "list_filtered"], elementType: "action_button" },
    "experiences_tab": { events: ["activity_view_changed"], elementType: "tab" },
    "page_view_page": { events: ["activity_viewed"], elementType: "page" },
    "photo_target_area": { events: ["photo_lightbox_opened"], elementType: "target_area" },
    "photos_tab": { events: ["activity_view_changed"], elementType: "tab" },
    "tag_tab": { events: ["activity_view_changed"], elementType: "tab" },
  },
  "add_alert_form": {
    "apply_action_button": { events: ["alert_added"], elementType: "action_button" },
    "close_action_button": { events: ["add_alert_form_closed"], elementType: "action_button" },
    "close_control_button": { events: ["add_alert_form_closed"], elementType: "control_button" },
    "page_view_page": { events: ["add_alert_form_opened"], elementType: "page" },
    "report_action_button": { events: ["alert_added", "nearby_required_dialog_opened"], elementType: "action_button" },
    "share_experience_action_button": { events: ["share_experience_form_opened"], elementType: "action_button" },
  },
  "add_floor_note_form": {
    "back_action_button": { events: ["add_mapper_note_form_closed"], elementType: "action_button" },
    "cancel_action_button": { events: ["add_mapper_note_form_closed"], elementType: "action_button" },
    "page_view_page": { events: ["add_mapper_note_form_opened"], elementType: "page" },
    "save_action_button": { events: ["alert_added"], elementType: "action_button" },
  },
  "add_handover_note_form": {
    "back_action_button": { events: ["add_mapper_note_form_closed"], elementType: "action_button" },
    "cancel_action_button": { events: ["add_mapper_note_form_closed"], elementType: "action_button" },
    "page_view_page": { events: ["add_mapper_note_form_opened"], elementType: "page" },
    "save_action_button": { events: ["alert_added"], elementType: "action_button" },
  },
  "add_info_menu": {
    "upload_photos_menu_list": { events: ["place_tag_add_cta_activated"], elementType: "menu_list" },
  },
  "add_mapper_note_form": {
    "close_action_button": { events: ["add_mapper_note_form_closed"], elementType: "action_button" },
    "page_view_page": { events: ["add_mapper_note_form_opened"], elementType: "page" },
    "submit_action_button": { events: ["alert_added"], elementType: "action_button" },
  },
  "add_note_menu": {
    "close_action_button": { events: ["add_note_menu_closed"], elementType: "action_button" },
    "page_view_page": { events: ["add_note_menu_opened"], elementType: "page" },
  },
  "add_space_form": {
    "cancel_action_button": { events: ["add_space_discard_dialog_closed", "add_space_discard_dialog_opened"], elementType: "action_button" },
    "close_action_button": { events: ["add_space_discard_dialog_opened"], elementType: "action_button" },
    "confirm_action_button": { events: ["add_space_form_closed"], elementType: "action_button" },
    "page_view_page": { events: ["add_space_form_opened"], elementType: "page" },
    "save_action_button": { events: ["space_added"], elementType: "action_button" },
  },
  "alert_added_confirmation": {
    "add_another_action_button": { events: ["add_alert_form_opened"], elementType: "action_button" },
    "notify_me_action_button": { events: ["place_notification_form_opened"], elementType: "action_button" },
    "page_view_page": { events: ["alert_added_confirmation_viewed"], elementType: "page" },
    "view_alerts_action_button": { events: ["view_place_cta_activated"], elementType: "action_button" },
  },
  "analytics": {
    "page_view_page": { events: ["analytics_page_viewed"], elementType: "page" },
    "select_site_control_button": { events: ["analytics_site_changed"], elementType: "control_button" },
  },
  "app_accessibility": {
    "bold_text_toggle": { events: ["app_accessibility_setting_changed"], elementType: "toggle" },
    "device_system_settings_toggle": { events: ["app_accessibility_setting_changed"], elementType: "toggle" },
    "enable_dark_mode_toggle": { events: ["app_accessibility_setting_changed"], elementType: "toggle" },
    "increase_contrast_toggle": { events: ["app_accessibility_setting_changed"], elementType: "toggle" },
    "page_view_page": { events: ["app_accessibility_viewed"], elementType: "page" },
    "text_size_slider": { events: ["app_accessibility_setting_changed"], elementType: "slider" },
  },
  "app_permissions": {
    "camera_access_toggle": { events: ["device_permission_changed"], elementType: "toggle" },
    "location_tracking_toggle": { events: ["device_permission_changed"], elementType: "toggle" },
    "page_view_page": { events: ["device_permissions_viewed"], elementType: "page" },
    "photos_access_toggle": { events: ["device_permission_changed"], elementType: "toggle" },
  },
  "area_map": {
    "area_map_item_card": { events: ["area_map_results_viewed"], elementType: "card" },
    "page_view_page": { events: ["area_map_viewed"], elementType: "page" },
  },
  "area_map_results": {
    "add_info_action_button": { events: ["place_info_add_cta_activated"], elementType: "action_button" },
    "add_note_action_button": { events: ["place_alert_add_cta_activated"], elementType: "action_button" },
    "add_tags_action_button": { events: ["place_tag_add_cta_activated"], elementType: "action_button" },
    "apply_action_button": { events: ["filter_applied"], elementType: "action_button" },
    "back_action_button": { events: ["filter_closed"], elementType: "action_button" },
    "clear_all_action_button": { events: ["filter_cleared"], elementType: "action_button" },
    "filter_action_button": { events: ["filter_opened"], elementType: "action_button" },
    "get_alert_action_button": { events: ["place_notification_cta_activated"], elementType: "action_button" },
    "page_view_page": { events: ["area_map_results_viewed"], elementType: "page" },
    "place_card_card": { events: ["place_viewed"], elementType: "card" },
    "place_pin_target_area": { events: ["place_pin_selected"], elementType: "target_area" },
    "save_place_action_button": { events: ["place_save_cta_activated"], elementType: "action_button" },
    "share_place_action_button": { events: ["area_map_share_cta_activated"], elementType: "action_button" },
    "sort_dropdown_sort": { events: ["sort_changed"], elementType: "sort" },
    "view_filter_toggle": { events: ["map_view_changed"], elementType: "toggle" },
  },
  "assign_alt_text": {
    "back_action_button": { events: ["assign_alt_text_discard_dialog_opened", "assign_alt_text_step_viewed", "manage_photo_viewed"], elementType: "action_button" },
    "cancel_action_button": { events: ["assign_alt_text_discard_dialog_closed", "remove_photo_dialog_closed"], elementType: "action_button" },
    "confirm_action_button": { events: ["assign_alt_text_discard_dialog_closed", "space_photo_removed"], elementType: "action_button" },
    "delete_action_button": { events: ["remove_photo_dialog_opened"], elementType: "action_button" },
    "next_action_button": { events: ["assign_alt_text_step_viewed"], elementType: "action_button" },
    "page_view_page": { events: ["assign_alt_text_step_viewed"], elementType: "page" },
    "save_changes_action_button": { events: ["manage_photo_viewed"], elementType: "action_button" },
  },
  "assign_tags": {
    "back_action_button": { events: ["assign_tags_discard_dialog_opened", "assign_tags_step_viewed"], elementType: "action_button" },
    "cancel_action_button": { events: ["assign_tags_discard_dialog_closed"], elementType: "action_button" },
    "continue_action_button": { events: ["assign_tags_discard_dialog_closed"], elementType: "action_button" },
    "finish_tagging_action_button": { events: ["space_tags_added"], elementType: "action_button" },
    "next_action_button": { events: ["assign_tags_step_viewed"], elementType: "action_button" },
    "page_view_page": { events: ["assign_tags_step_viewed"], elementType: "page" },
    "photo_carousel_target_area": { events: ["photo_navigated"], elementType: "target_area" },
  },
  "auth_landing": {
    "close_action_button": { events: ["auth_form_closed"], elementType: "action_button" },
    "continue_action_button": { events: ["account_login_failed", "auth_email_submitted"], elementType: "action_button" },
    "continue_with_apple_action_button": { events: ["auth_social_cta_activated"], elementType: "action_button" },
    "continue_with_facebook_action_button": { events: ["auth_social_cta_activated"], elementType: "action_button" },
    "continue_with_google_action_button": { events: ["auth_social_cta_activated"], elementType: "action_button" },
    "page_view_page": { events: ["auth_form_opened"], elementType: "page" },
  },
  "auth_password": {
    "back_action_button": { events: ["auth_form_opened"], elementType: "action_button" },
    "continue_action_button": { events: ["account_logged_in", "account_login_failed"], elementType: "action_button" },
    "forgot_password_link_button": { events: ["forgot_password_cta_activated"], elementType: "link_button" },
    "page_view_page": { events: ["auth_password_viewed"], elementType: "page" },
    "password_visibility_toggle_toggle": { events: ["password_visibility_toggled"], elementType: "toggle" },
  },
  "auth_password_reset": {
    "back_action_button": { events: ["home_page_viewed"], elementType: "action_button" },
    "page_view_page": { events: ["auth_password_reset_viewed"], elementType: "page" },
    "update_password_action_button": { events: ["password_reset_completed"], elementType: "action_button" },
  },
  "auth_signup": {
    "back_action_button": { events: ["auth_form_opened"], elementType: "action_button" },
    "continue_action_button": { events: ["account_created"], elementType: "action_button" },
    "page_view_page": { events: ["auth_signup_viewed"], elementType: "page" },
    "password_visibility_toggle_toggle": { events: ["password_visibility_toggled"], elementType: "toggle" },
    "privacy_notice_link_link_button": { events: ["external_link_cta_activated"], elementType: "link_button" },
    "terms_and_conditions_link_link_button": { events: ["external_link_cta_activated"], elementType: "link_button" },
  },
  "badges": {
    "page_view_page": { events: ["badges_viewed"], elementType: "page" },
  },
  "block_user_form": {
    "close_action_button": { events: ["block_user_form_closed"], elementType: "action_button" },
    "page_view_page": { events: ["block_user_form_opened"], elementType: "page" },
    "submit_action_button": { events: ["user_blocked"], elementType: "action_button" },
  },
  "brand": {
    "brand_item_card": { events: ["place_search_performed"], elementType: "card" },
    "page_view_page": { events: ["brand_viewed"], elementType: "page" },
  },
  "change_cover_photo_form": {
    "close_action_button": { events: ["change_cover_photo_form_closed"], elementType: "action_button" },
    "page_view_page": { events: ["change_cover_photo_form_opened"], elementType: "page" },
    "retake_photo_link_button": { events: ["photo_source_menu_opened"], elementType: "link_button" },
    "save_action_button": { events: ["cover_photo_updated"], elementType: "action_button" },
  },
  "change_location_list": {
    "city_item_chip": { events: ["location_changed"], elementType: "chip" },
    "close_action_button": { events: ["change_location_list_closed"], elementType: "action_button" },
    "current_location_menu_list": { events: ["location_changed"], elementType: "menu_list" },
    "page_view_page": { events: ["change_location_list_viewed"], elementType: "page" },
    "search_bar_input_field": { events: ["location_changed"], elementType: "input_field" },
    "section_header_link_button": { events: ["other_cities_viewed"], elementType: "link_button" },
    "set_location_on_map_link_button": { events: ["change_location_map_form_opened"], elementType: "link_button" },
  },
  "change_location_map_form": {
    "back_action_button": { events: ["change_location_map_form_closed"], elementType: "action_button" },
    "page_view_page": { events: ["change_location_map_form_opened"], elementType: "page" },
    "select_location_action_button": { events: ["location_changed"], elementType: "action_button" },
  },
  "claim_business_form": {
    "close_action_button": { events: ["claim_business_form_closed"], elementType: "action_button" },
    "page_view_page": { events: ["claim_business_form_opened"], elementType: "page" },
    "submit_claim_action_button": { events: ["business_claimed"], elementType: "action_button" },
  },
  "create_saved_list_form": {
    "close_action_button": { events: ["create_saved_list_form_closed"], elementType: "action_button" },
    "continue_action_button": { events: ["saved_list_created"], elementType: "action_button" },
    "create_action_button": { events: ["saved_list_created"], elementType: "action_button" },
    "page_view_page": { events: ["create_saved_list_form_opened"], elementType: "page" },
  },
  "custom_info_editor": {
    "close_control_button": { events: ["custom_info_editor_closed"], elementType: "control_button" },
    "page_view_page": { events: ["custom_info_editor_opened"], elementType: "page" },
    "save_action_button": { events: ["custom_info_added", "custom_info_edited"], elementType: "action_button" },
  },
  "duplicate_space_form": {
    "close_action_button": { events: ["duplicate_space_form_closed"], elementType: "action_button" },
    "duplicate_action_button": { events: ["space_added"], elementType: "action_button" },
    "page_view_page": { events: ["duplicate_space_form_opened"], elementType: "page" },
  },
  "edit_alert_form": {
    "close_action_button": { events: ["edit_alert_form_closed"], elementType: "action_button" },
    "close_control_button": { events: ["edit_alert_form_closed"], elementType: "control_button" },
    "page_view_page": { events: ["edit_alert_form_opened"], elementType: "page" },
    "save_action_button": { events: ["alert_edited"], elementType: "action_button" },
    "save_changes_action_button": { events: ["alert_edited"], elementType: "action_button" },
  },
  "edit_space_form": {
    "cancel_action_button": { events: ["delete_space_dialog_closed", "edit_space_discard_dialog_closed"], elementType: "action_button" },
    "close_action_button": { events: ["edit_space_discard_dialog_opened"], elementType: "action_button" },
    "confirm_action_button": { events: ["edit_space_form_closed", "space_deleted"], elementType: "action_button" },
    "delete_space_action_button": { events: ["delete_space_dialog_opened"], elementType: "action_button" },
    "page_view_page": { events: ["edit_space_form_opened"], elementType: "page" },
    "update_action_button": { events: ["space_edited"], elementType: "action_button" },
  },
  "edit_tags": {
    "add_photo_action_button": { events: ["space_photo_added"], elementType: "action_button" },
    "back_action_button": { events: ["tag_header_viewed", "tag_space_details_viewed"], elementType: "action_button" },
    "confirm_action_button": { events: ["space_deleted", "space_photo_removed"], elementType: "action_button" },
    "next_action_button": { events: ["space_tags_edited"], elementType: "action_button" },
    "page_view_page": { events: ["edit_tags_viewed"], elementType: "page" },
    "save_action_button": { events: ["space_tags_added", "space_tags_edited"], elementType: "action_button" },
  },
  "filter": {
    "apply_action_button": { events: ["filter_applied"], elementType: "action_button" },
    "clear_all_action_button": { events: ["filter_cleared"], elementType: "action_button" },
    "close_action_button": { events: ["filter_closed"], elementType: "action_button" },
    "page_view_page": { events: ["filter_opened"], elementType: "page" },
  },
  "finish_tagging": {
    "page_view_page": { events: ["finish_tagging_viewed"], elementType: "page" },
  },
  "flag_alert_form": {
    "close_action_button": { events: ["flag_alert_form_closed"], elementType: "action_button" },
    "page_view_page": { events: ["flag_alert_form_opened"], elementType: "page" },
    "submit_flag_action_button": { events: ["alert_flagged"], elementType: "action_button" },
  },
  "flag_photo_form": {
    "close_action_button": { events: ["flag_photo_form_closed"], elementType: "action_button" },
    "page_view_page": { events: ["flag_photo_form_opened"], elementType: "page" },
    "submit_flag_action_button": { events: ["photo_flagged"], elementType: "action_button" },
  },
  "flag_space_form": {
    "back_action_button": { events: ["flag_space_form_closed"], elementType: "action_button" },
    "page_view_page": { events: ["flag_space_form_opened"], elementType: "page" },
    "submit_flag_action_button": { events: ["space_flagged"], elementType: "action_button" },
  },
  "flag_user_form": {
    "close_action_button": { events: ["flag_user_form_closed"], elementType: "action_button" },
    "page_view_page": { events: ["flag_user_form_opened"], elementType: "page" },
    "submit_flag_action_button": { events: ["user_flagged"], elementType: "action_button" },
  },
  "guide_editor": {
    "close_control_button": { events: ["guide_editor_closed"], elementType: "control_button" },
    "copy_link_action_button": { events: ["guide_link_copy_cta_activated"], elementType: "action_button" },
    "page_view_page": { events: ["guide_editor_opened"], elementType: "page" },
    "save_action_button": { events: ["guide_added", "guide_edited"], elementType: "action_button" },
  },
  "help_menu": {
    "contact_support_menu_list": { events: ["support_page_viewed"], elementType: "menu_list" },
    "guidance_menu_list": { events: ["support_cta_activated"], elementType: "menu_list" },
  },
  "home": {
    "accessibility_feature_chip": { events: ["filter_opened"], elementType: "chip" },
    "add_info_action_button": { events: ["place_info_add_cta_activated"], elementType: "action_button" },
    "add_note_action_button": { events: ["place_alert_add_cta_activated"], elementType: "action_button" },
    "add_tags_action_button": { events: ["place_tag_add_cta_activated"], elementType: "action_button" },
    "all_tab": { events: ["notification_view_changed"], elementType: "tab" },
    "area_map_item_card": { events: ["area_map_results_viewed"], elementType: "card" },
    "avatar_action_button": { events: ["profile_menu_opened"], elementType: "action_button" },
    "blog_card_card": { events: ["blog_cta_activated"], elementType: "card" },
    "brand_item_card": { events: ["place_search_performed"], elementType: "card" },
    "city_item_card": { events: ["location_changed"], elementType: "card" },
    "clear_action_button": { events: ["search_cleared"], elementType: "action_button" },
    "contact_support_card": { events: ["support_page_viewed"], elementType: "card" },
    "get_alert_action_button": { events: ["place_notification_cta_activated"], elementType: "action_button" },
    "hamburger_menu_action_button": { events: ["profile_menu_opened"], elementType: "action_button" },
    "live_alerts_tab": { events: ["notification_view_changed"], elementType: "tab" },
    "location_label_link_button": { events: ["change_location_list_viewed"], elementType: "link_button" },
    "manage_notification_action_button": { events: ["manage_notifications_viewed"], elementType: "action_button" },
    "map_target_area": { events: ["place_search_results_viewed"], elementType: "target_area" },
    "mark_all_read_link_button": { events: ["notifications_all_read"], elementType: "link_button" },
    "more_link_button": { events: ["neighborhood_viewed", "recent_searches_viewed"], elementType: "link_button" },
    "nearby_places_link_button": { events: ["place_search_performed"], elementType: "link_button" },
    "neighborhood_item_card": { events: ["place_search_performed"], elementType: "card" },
    "new_accessibility_info_tab": { events: ["notification_view_changed"], elementType: "tab" },
    "notification_item_card": { events: ["place_viewed"], elementType: "card" },
    "notification_nav_action_button": { events: ["notifications_viewed"], elementType: "action_button" },
    "opening_hour_chip": { events: ["filter_opened"], elementType: "chip" },
    "overflow_action_button": { events: ["notification_read"], elementType: "action_button" },
    "page_view_page": { events: ["home_page_viewed"], elementType: "page" },
    "place_card_carousel_target_area": { events: ["place_carousel_navigated"], elementType: "target_area" },
    "place_card_target_area": { events: ["place_viewed"], elementType: "target_area" },
    "place_category_chip": { events: ["filter_opened"], elementType: "chip" },
    "recent_search_item_card": { events: ["place_search_performed"], elementType: "card" },
    "recent_search_item_chip": { events: ["place_search_performed"], elementType: "chip" },
    "save_action_button": { events: ["place_save_cta_activated"], elementType: "action_button" },
    "save_nav_action_button": { events: ["auth_form_opened", "saved_places_viewed"], elementType: "action_button" },
    "saved_search_chip": { events: ["saved_searches_viewed"], elementType: "chip" },
    "saved_search_item_card": { events: ["place_search_performed"], elementType: "card" },
    "search_bar_input_field": { events: ["search_list_viewed"], elementType: "input_field" },
    "search_submit_action_button": { events: ["filter_applied", "place_search_performed"], elementType: "action_button" },
    "section_header_link_button": { events: ["area_map_viewed", "brand_viewed", "other_cities_viewed", "place_search_results_viewed"], elementType: "link_button" },
    "see_analytics_link_button": { events: ["analytics_page_viewed"], elementType: "link_button" },
    "show_nearest_results_action_button": { events: ["place_search_results_viewed"], elementType: "action_button" },
    "subscribe_action_button": { events: ["community_subscribe_cta_activated"], elementType: "action_button" },
    "turn_on_location_action_button": { events: ["location_cta_activated"], elementType: "action_button" },
    "unread_only_toggle": { events: ["notifications_filter_toggled"], elementType: "toggle" },
    "view_all_notifications_link_button": { events: ["notifications_viewed"], elementType: "link_button" },
  },
  "login": {
    "continue_with_google_action_button": { events: ["auth_social_cta_activated"], elementType: "action_button" },
    "continue_with_microsoft_action_button": { events: ["auth_social_cta_activated"], elementType: "action_button" },
    "login_action_button": { events: ["account_logged_in", "account_login_failed"], elementType: "action_button" },
    "page_view_page": { events: ["account_auto_logged_in"], elementType: "page" },
  },
  "manage_account": {
    "accessibility_features_link_button": { events: ["saved_accessibility_filters_form_opened"], elementType: "link_button" },
    "avatar_target_area": { events: ["photo_source_menu_opened"], elementType: "target_area" },
    "cancel_action_button": { events: ["delete_account_dialog_closed"], elementType: "action_button" },
    "confirm_delete_action_button": { events: ["account_deleted"], elementType: "action_button" },
    "delete_account_action_button": { events: ["delete_account_dialog_opened"], elementType: "action_button" },
    "page_view_page": { events: ["manage_account_viewed"], elementType: "page" },
    "personal_details_link_button": { events: ["update_personal_details_form_opened"], elementType: "link_button" },
    "profile_activity_toggle": { events: ["account_privacy_changed"], elementType: "toggle" },
    "show_disability_toggle": { events: ["account_privacy_changed"], elementType: "toggle" },
    "update_password_action_button": { events: ["update_password_form_opened"], elementType: "action_button" },
    "update_profile_link_button": { events: ["accessibility_profile_form_opened"], elementType: "link_button" },
  },
  "manage_notification_form": {
    "close_action_button": { events: ["manage_notification_form_closed"], elementType: "action_button" },
    "page_view_page": { events: ["manage_notification_form_opened"], elementType: "page" },
    "update_action_button": { events: ["place_notification_subscribed", "place_notification_unsubscribed"], elementType: "action_button" },
  },
  "manage_notifications": {
    "all_tab": { events: ["notification_view_changed"], elementType: "tab" },
    "live_alerts_tab": { events: ["notification_view_changed"], elementType: "tab" },
    "new_accessibility_info_tab": { events: ["notification_view_changed"], elementType: "tab" },
    "page_view_page": { events: ["manage_notifications_viewed"], elementType: "page" },
    "place_notification_bell_control_button": { events: ["manage_notification_form_opened"], elementType: "control_button" },
    "search_bar_input_field": { events: ["list_filtered"], elementType: "input_field" },
    "show_only_without_data_toggle": { events: ["notifications_filter_toggled"], elementType: "toggle" },
    "sort_dropdown_sort": { events: ["sort_changed"], elementType: "sort" },
  },
  "manage_photo": {
    "cancel_action_button": { events: ["remove_photo_dialog_closed"], elementType: "action_button" },
    "confirm_action_button": { events: ["space_photo_removed"], elementType: "action_button" },
    "delete_action_button": { events: ["remove_photo_dialog_opened"], elementType: "action_button" },
    "from_photos_action_button": { events: ["photo_source_cta_activated"], elementType: "action_button" },
    "page_view_page": { events: ["manage_photo_viewed"], elementType: "page" },
    "photo_thumbnail_target_area": { events: ["assign_alt_text_step_viewed"], elementType: "target_area" },
    "save_action_button": { events: ["photo_source_menu_opened"], elementType: "action_button" },
    "submit_photo_action_button": { events: ["space_photo_added"], elementType: "action_button" },
    "take_photo_action_button": { events: ["photo_source_cta_activated"], elementType: "action_button" },
  },
  "manage_widget": {
    "add_widget_action_button": { events: ["widget_editor_opened"], elementType: "action_button" },
    "delete_action_button": { events: ["widget_deleted"], elementType: "action_button" },
    "edit_action_button": { events: ["widget_editor_opened"], elementType: "action_button" },
    "status_toggle_toggle": { events: ["widget_status_changed"], elementType: "toggle" },
  },
  "my_business": {
    "manage_action_button": { events: ["add_alert_form_opened"], elementType: "action_button" },
    "page_view_page": { events: ["my_business_viewed"], elementType: "page" },
    "view_place_action_button": { events: ["view_place_cta_activated"], elementType: "action_button" },
  },
  "nav": {
    "analytics_tab": { events: ["analytics_page_viewed"], elementType: "tab" },
    "support_tab": { events: ["support_page_viewed"], elementType: "tab" },
  },
  "nav_tree": {
    "accessibility_features_menu_list": { events: ["filter_applied", "filter_opened"], elementType: "menu_list" },
    "close_action_button": { events: ["nav_tree_closed"], elementType: "action_button" },
    "floor_menu_list": { events: ["filter_applied", "filter_opened"], elementType: "menu_list" },
    "page_view_page": { events: ["nav_tree_viewed"], elementType: "page" },
    "search_input_field": { events: ["list_filtered"], elementType: "input_field" },
    "space_card": { events: ["place_header_view_changed", "place_space_viewed"], elementType: "card" },
  },
  "neighborhood": {
    "neighborhood_item_card": { events: ["place_search_performed"], elementType: "card" },
    "page_view_page": { events: ["neighborhood_viewed"], elementType: "page" },
  },
  "notifications": {
    "all_tab": { events: ["notification_view_changed"], elementType: "tab" },
    "live_alerts_tab": { events: ["notification_view_changed"], elementType: "tab" },
    "login_action_button": { events: ["auth_form_opened"], elementType: "action_button" },
    "mark_all_read_link_button": { events: ["notifications_all_read"], elementType: "link_button" },
    "new_accessibility_info_tab": { events: ["notification_view_changed"], elementType: "tab" },
    "notification_item_card": { events: ["notification_read", "place_viewed"], elementType: "card" },
    "overflow_action_button": { events: ["notification_read"], elementType: "action_button" },
    "page_view_page": { events: ["notifications_viewed"], elementType: "page" },
    "search_bar_input_field": { events: ["list_filtered"], elementType: "input_field" },
    "settings_action_button": { events: ["manage_notifications_viewed"], elementType: "action_button" },
    "unread_only_toggle": { events: ["notifications_filter_toggled"], elementType: "toggle" },
  },
  "onboarding": {
    "lets_start_action_button": { events: ["onboarding_completed"], elementType: "action_button" },
    "next_action_button": { events: ["onboarding_step_viewed"], elementType: "action_button" },
    "page_view_page": { events: ["onboarding_step_viewed"], elementType: "page" },
    "previous_action_button": { events: ["onboarding_step_viewed"], elementType: "action_button" },
    "skip_action_button": { events: ["onboarding_skipped"], elementType: "action_button" },
  },
  "other_cities": {
    "explore_other_cities_card": { events: ["location_changed"], elementType: "card" },
    "page_view_page": { events: ["other_cities_viewed"], elementType: "page" },
  },
  "password_reset_request_form": {
    "back_action_button": { events: ["password_reset_request_form_closed"], elementType: "action_button" },
    "continue_action_button": { events: ["password_reset_requested"], elementType: "action_button" },
    "log_in_here_link_button": { events: ["auth_form_opened"], elementType: "link_button" },
    "page_view_page": { events: ["password_reset_request_form_opened"], elementType: "page" },
  },
  "photo_guide": {
    "page_view_page": { events: ["photo_guide_viewed"], elementType: "page" },
  },
  "photo_light_box": {
    "accessibility_tags_tab": { events: ["photo_info_view_changed"], elementType: "tab" },
    "alt_text_tab": { events: ["photo_info_view_changed"], elementType: "tab" },
    "alt_text_toggle_toggle": { events: ["photo_alt_text_toggled"], elementType: "toggle" },
    "close_action_button": { events: ["photo_action_menu_closed", "photo_lightbox_closed"], elementType: "action_button" },
    "close_control_button": { events: ["photo_lightbox_closed"], elementType: "control_button" },
    "expand_action_button": { events: ["photo_info_opened"], elementType: "action_button" },
    "flag_action_button": { events: ["photo_flag_cta_activated"], elementType: "action_button" },
    "more_options_action_button": { events: ["photo_action_menu_opened"], elementType: "action_button" },
    "page_view_page": { events: ["photo_lightbox_opened"], elementType: "page" },
    "photo_accessibility_info_close_action_button": { events: ["photo_info_closed"], elementType: "action_button" },
    "photo_accessibility_info_expand_action_button": { events: ["photo_info_opened"], elementType: "action_button" },
    "photo_pagination_action_button": { events: ["photo_navigated"], elementType: "action_button" },
    "photo_pagination_control_button": { events: ["photo_navigated"], elementType: "control_button" },
    "photo_target_area": { events: ["photo_navigated"], elementType: "target_area" },
    "photo_thumbnail_target_area": { events: ["photo_navigated"], elementType: "target_area" },
    "zoom_control_button": { events: ["photo_zoomed"], elementType: "control_button" },
    "zoom_in_action_button": { events: ["photo_zoomed"], elementType: "action_button" },
    "zoom_out_action_button": { events: ["photo_zoomed"], elementType: "action_button" },
    "zoom_reset_action_button": { events: ["photo_zoomed"], elementType: "action_button" },
  },
  "place": {
    "I_want_to_know_link_button": { events: ["place_notification_cta_activated"], elementType: "link_button" },
    "about_tab": { events: ["place_info_view_changed"], elementType: "tab" },
    "accessibility_alerts_banner_link_button": { events: ["accessibility_alerts_viewed"], elementType: "link_button" },
    "accessibility_chip_chip": { events: ["place_header_view_changed"], elementType: "chip" },
    "accessibility_tab": { events: ["place_info_view_changed"], elementType: "tab" },
    "add_alert_action_button": { events: ["add_alert_form_opened"], elementType: "action_button" },
    "add_guide_action_button": { events: ["guide_editor_opened"], elementType: "action_button" },
    "add_information_action_button": { events: ["custom_info_editor_opened"], elementType: "action_button" },
    "add_note_action_button": { events: ["add_note_menu_opened"], elementType: "action_button" },
    "add_space_action_button": { events: ["add_space_form_opened"], elementType: "action_button" },
    "add_tags_action_button": { events: ["place_tag_add_cta_activated"], elementType: "action_button" },
    "address_link_button": { events: ["place_external_link_cta_activated"], elementType: "link_button" },
    "alert_snippet_target_area": { events: ["place_alert_expanded"], elementType: "target_area" },
    "alerts_menu_list": { events: ["add_alert_form_opened"], elementType: "menu_list" },
    "alerts_tab": { events: ["place_info_view_changed"], elementType: "tab" },
    "apply_action_button": { events: ["filter_applied"], elementType: "action_button" },
    "back_action_button": { events: ["place_closed"], elementType: "action_button" },
    "bathroom_chip": { events: ["place_header_view_changed"], elementType: "chip" },
    "bell_action_button": { events: ["place_notification_cta_activated"], elementType: "action_button" },
    "by_users_tab": { events: ["photo_collection_view_changed"], elementType: "tab" },
    "cancel_action_button": { events: ["resolve_alert_dialog_closed", "vote_alert_form_closed"], elementType: "action_button" },
    "claim_business_link_button": { events: ["place_claim_cta_activated"], elementType: "link_button" },
    "clear_all_action_button": { events: ["filter_cleared"], elementType: "action_button" },
    "client_webpage_link_link_button": { events: ["external_link_cta_activated", "widget_redirect_cta_activated"], elementType: "link_button" },
    "close_action_button": { events: ["place_closed"], elementType: "action_button" },
    "close_control_button": { events: ["filter_closed", "widget_closed"], elementType: "control_button" },
    "close_flag_action_button": { events: ["flag_closed"], elementType: "action_button" },
    "confirm_action_button": { events: ["alert_resolved"], elementType: "action_button" },
    "confirm_delete_action_button": { events: ["alert_deleted"], elementType: "action_button" },
    "custom_info_card_card": { events: ["place_custom_info_viewed"], elementType: "card" },
    "delete_action_button": { events: ["custom_info_deleted", "guide_deleted"], elementType: "action_button" },
    "duplicate_action_button": { events: ["guide_duplicated"], elementType: "action_button" },
    "edit_action_button": { events: ["custom_info_editor_opened", "guide_editor_opened"], elementType: "action_button" },
    "edit_information_action_button": { events: ["edit_tags_viewed"], elementType: "action_button" },
    "edit_pencil_action_button": { events: ["edit_alert_form_opened"], elementType: "action_button" },
    "edit_pencil_icon": { events: ["edit_alert_form_opened"], elementType: "icon" },
    "edit_space_action_button": { events: ["edit_space_form_opened"], elementType: "action_button" },
    "entrances_and_exits_chip": { events: ["place_header_view_changed"], elementType: "chip" },
    "experiences_tab": { events: ["place_info_view_changed"], elementType: "tab" },
    "filter_control_button": { events: ["filter_opened"], elementType: "control_button" },
    "filter_input_input_field": { events: ["list_filtered"], elementType: "input_field" },
    "flag_action_button": { events: ["alert_flag_cta_activated", "flag_experience_form_opened"], elementType: "action_button" },
    "guide_card_card": { events: ["accessibility_guide_viewed"], elementType: "card" },
    "hero_photo_carousel_target_area": { events: ["photo_navigated"], elementType: "target_area" },
    "indoor_area_chip": { events: ["place_header_view_changed"], elementType: "chip" },
    "live_alerts_chip": { events: ["place_alert_view_changed"], elementType: "chip" },
    "make_a_booking_link_button": { events: ["place_external_link_cta_activated"], elementType: "link_button" },
    "mapper_note_chip": { events: ["place_alert_view_changed"], elementType: "chip" },
    "mapper_note_menu_list": { events: ["add_mapper_note_form_opened"], elementType: "menu_list" },
    "more_link_button": { events: ["place_summary_expanded"], elementType: "link_button" },
    "nav_tree_expand_control_button": { events: ["nav_tree_viewed"], elementType: "control_button" },
    "no_action_button": { events: ["vote_alert_cta_activated"], elementType: "action_button" },
    "no_resolve_action_button": { events: ["resolve_alert_dialog_opened"], elementType: "action_button" },
    "not_sure_action_button": { events: ["vote_alert_cta_activated"], elementType: "action_button" },
    "notes_chip": { events: ["place_alert_view_changed"], elementType: "chip" },
    "opening_hour_action_button": { events: ["place_opening_hours_expanded"], elementType: "action_button" },
    "outdoor_area_chip": { events: ["place_header_view_changed"], elementType: "chip" },
    "page_view_page": { events: ["place_viewed", "vote_alert_form_opened", "widget_loaded", "widget_opened"], elementType: "page" },
    "photo_gallery_expand_action_button": { events: ["photo_gallery_viewed"], elementType: "action_button" },
    "photo_target_area": { events: ["photo_gallery_viewed"], elementType: "target_area" },
    "photos_tab": { events: ["place_info_view_changed"], elementType: "tab" },
    "place_summary_action_button": { events: ["place_summary_expanded"], elementType: "action_button" },
    "place_summary_target_area": { events: ["place_summary_expanded"], elementType: "target_area" },
    "reorder_control_button": { events: ["custom_info_reordered"], elementType: "control_button" },
    "report_alerts_action_button": { events: ["place_alert_add_cta_activated"], elementType: "action_button" },
    "save_action_button": { events: ["alert_voted"], elementType: "action_button" },
    "save_place_action_button": { events: ["place_save_cta_activated"], elementType: "action_button" },
    "search_place_input_field": { events: ["space_search_performed"], elementType: "input_field" },
    "share_experience_action_button": { events: ["place_experience_share_cta_activated"], elementType: "action_button" },
    "share_place_action_button": { events: ["place_share_cta_activated"], elementType: "action_button" },
    "sort_dropdown_sort": { events: ["sort_changed"], elementType: "sort" },
    "space_card": { events: ["place_space_viewed"], elementType: "card" },
    "space_card_photo_carousel_action_button": { events: ["photo_navigated"], elementType: "action_button" },
    "space_card_photo_carousel_target_area": { events: ["photo_lightbox_opened", "photo_navigated"], elementType: "target_area" },
    "space_item_menu_list": { events: ["place_header_view_changed"], elementType: "menu_list" },
    "status_toggle_toggle": { events: ["custom_info_edited", "guide_edited"], elementType: "toggle" },
    "sub_nav_tab": { events: ["place_content_view_changed"], elementType: "tab" },
    "subscribe_live_alerts_action_button": { events: ["place_notification_cta_activated"], elementType: "action_button" },
    "undo_action_button": { events: ["alert_unvoted"], elementType: "action_button" },
    "view_on_map_link_button": { events: ["area_map_viewed"], elementType: "link_button" },
    "walkthrough_tab": { events: ["photo_collection_view_changed"], elementType: "tab" },
    "website_link_button": { events: ["place_external_link_cta_activated"], elementType: "link_button" },
    "yes_action_button": { events: ["vote_alert_cta_activated"], elementType: "action_button" },
  },
  "place_custom_info": {
    "page_view_page": { events: ["place_custom_info_viewed"], elementType: "page" },
  },
  "place_notification_form": {
    "close_action_button": { events: ["place_notification_form_closed"], elementType: "action_button" },
    "done_action_button": { events: ["place_notification_subscribed", "place_notification_unsubscribed"], elementType: "action_button" },
    "page_view_page": { events: ["place_notification_form_opened"], elementType: "page" },
  },
  "place_search_results": {
    "accessibility_chip_chip": { events: ["filter_opened"], elementType: "chip" },
    "add_note_action_button": { events: ["place_alert_add_cta_activated"], elementType: "action_button" },
    "add_tags_action_button": { events: ["place_tag_add_cta_activated"], elementType: "action_button" },
    "close_action_button": { events: ["saved_search_form_closed", "unsave_search_form_closed"], elementType: "action_button" },
    "current_location_action_button": { events: ["map_location_centered"], elementType: "action_button" },
    "filter_chip": { events: ["filter_opened"], elementType: "chip" },
    "get_alert_action_button": { events: ["place_notification_cta_activated"], elementType: "action_button" },
    "nearby_chip_chip": { events: ["filter_opened"], elementType: "chip" },
    "page_view_page": { events: ["place_search_results_viewed"], elementType: "page" },
    "pin_view_toggle_toggle": { events: ["search_results_pin_view_changed"], elementType: "toggle" },
    "place_card_card": { events: ["place_viewed"], elementType: "card" },
    "place_category_chip_chip": { events: ["filter_opened"], elementType: "chip" },
    "place_pin_target_area": { events: ["place_pin_selected"], elementType: "target_area" },
    "save_as_new_action_button": { events: ["saved_search_added"], elementType: "action_button" },
    "save_place_action_button": { events: ["place_save_cta_activated"], elementType: "action_button" },
    "save_search_action_button": { events: ["saved_search_cta_activated", "saved_search_form_opened"], elementType: "action_button" },
    "saved_chip_action_button": { events: ["unsave_search_form_opened"], elementType: "action_button" },
    "search_this_area_action_button": { events: ["place_search_performed"], elementType: "action_button" },
    "sort_dropdown_sort": { events: ["sort_changed"], elementType: "sort" },
    "unsave_action_button": { events: ["saved_search_removed"], elementType: "action_button" },
    "view_filter_toggle": { events: ["map_view_changed"], elementType: "toggle" },
    "zoom_control_control_button": { events: ["map_zoomed"], elementType: "control_button" },
  },
  "place_space": {
    "accessibility_alerts_banner_link_button": { events: ["accessibility_alerts_viewed"], elementType: "link_button" },
    "accessibility_features_menu_list": { events: ["filter_applied", "filter_opened"], elementType: "menu_list" },
    "close_action_button": { events: ["place_space_closed"], elementType: "action_button" },
    "connected_space_dropdown_action_button": { events: ["connected_space_list_viewed"], elementType: "action_button" },
    "connected_space_item_menu_list": { events: ["place_space_viewed"], elementType: "menu_list" },
    "flag_action_button": { events: ["space_flag_cta_activated"], elementType: "action_button" },
    "floor_menu_list": { events: ["filter_applied", "filter_opened"], elementType: "menu_list" },
    "nav_tree_expand_action_button": { events: ["nav_tree_viewed"], elementType: "action_button" },
    "next_space_action_button": { events: ["place_space_viewed"], elementType: "action_button" },
    "page_view_page": { events: ["place_space_viewed"], elementType: "page" },
    "photo_carousel_target_area": { events: ["photo_lightbox_opened"], elementType: "target_area" },
    "photo_pagination_action_button": { events: ["photo_navigated"], elementType: "action_button" },
    "previous_space_action_button": { events: ["place_space_viewed"], elementType: "action_button" },
    "search_label_input_field": { events: ["space_search_performed"], elementType: "input_field" },
    "share_action_button": { events: ["space_share_cta_activated"], elementType: "action_button" },
    "space_carousel_target_area": { events: ["place_space_viewed"], elementType: "target_area" },
    "space_item_menu_list": { events: ["place_space_viewed"], elementType: "menu_list" },
  },
  "profile_menu": {
    "about_sociability_link_button": { events: ["external_link_cta_activated"], elementType: "link_button" },
    "activity_menu_list": { events: ["activity_viewed"], elementType: "menu_list" },
    "app_accessibility_menu_list": { events: ["app_accessibility_viewed"], elementType: "menu_list" },
    "badges_menu_list": { events: ["badges_viewed"], elementType: "menu_list" },
    "close_action_button": { events: ["profile_menu_closed"], elementType: "action_button" },
    "device_permission_menu_list": { events: ["device_permissions_viewed"], elementType: "menu_list" },
    "faqs_link_button": { events: ["external_link_cta_activated"], elementType: "link_button" },
    "how_the_app_works_menu_list": { events: ["onboarding_step_viewed"], elementType: "menu_list" },
    "log_out_action_button": { events: ["account_logged_out"], elementType: "action_button" },
    "login_button_action_button": { events: ["auth_form_opened"], elementType: "action_button" },
    "manage_menu_list": { events: ["manage_account_viewed"], elementType: "menu_list" },
    "tagging_information_link_button": { events: ["external_link_cta_activated"], elementType: "link_button" },
    "team_menu_list": { events: ["team_landing_viewed"], elementType: "menu_list" },
  },
  "profile_setup": {
    "back_action_button": { events: ["profile_setup_step_viewed"], elementType: "action_button" },
    "close_action_button": { events: ["profile_setup_closed"], elementType: "action_button" },
    "continue_action_button": { events: ["profile_setup_submitted"], elementType: "action_button" },
    "page_view_page": { events: ["profile_setup_step_viewed"], elementType: "page" },
    "skip_for_now_link_button": { events: ["profile_setup_step_skipped"], elementType: "link_button" },
  },
  "recent_searches": {
    "page_view_page": { events: ["recent_searches_viewed"], elementType: "page" },
    "search_item_card": { events: ["place_search_performed"], elementType: "card" },
  },
  "save_place_form": {
    "close_action_button": { events: ["save_place_form_closed"], elementType: "action_button" },
    "create_list_link_button": { events: ["create_saved_list_form_opened"], elementType: "link_button" },
    "page_view_page": { events: ["save_place_form_opened"], elementType: "page" },
    "save_action_button": { events: ["place_notification_subscribed", "place_notification_unsubscribed", "saved_place_added", "saved_place_removed"], elementType: "action_button" },
  },
  "saved_accessibility_filters_form": {
    "close_action_button": { events: ["saved_accessibility_filters_form_closed"], elementType: "action_button" },
    "page_view_page": { events: ["saved_accessibility_filters_form_opened"], elementType: "page" },
    "update_action_button": { events: ["saved_accessibility_filters_updated"], elementType: "action_button" },
  },
  "saved_landing": {
    "add_saved_list_card": { events: ["create_saved_list_form_opened"], elementType: "card" },
    "log_in_to_start_action_button": { events: ["auth_form_opened"], elementType: "action_button" },
    "my_business_tab": { events: ["saved_my_business_viewed"], elementType: "tab" },
    "page_view_page": { events: ["saved_landing_viewed"], elementType: "page" },
    "saved_list_item_card": { events: ["saved_place_list_viewed"], elementType: "card" },
    "saved_search_item_card": { events: ["saved_search_details_viewed"], elementType: "card" },
    "section_header_link_button": { events: ["saved_places_viewed", "saved_searches_viewed"], elementType: "link_button" },
    "start_new_search_action_button": { events: ["search_page_viewed"], elementType: "action_button" },
  },
  "saved_place_list": {
    "cancel_action_button": { events: ["delete_saved_place_list_dialog_closed", "unsave_place_dialog_closed"], elementType: "action_button" },
    "cover_photo_menu_list": { events: ["photo_source_menu_opened"], elementType: "menu_list" },
    "current_location_action_button": { events: ["map_location_centered"], elementType: "action_button" },
    "delete_action_button": { events: ["saved_place_list_deleted", "saved_place_removed"], elementType: "action_button" },
    "delete_icon": { events: ["delete_saved_place_list_dialog_opened"], elementType: "icon" },
    "delete_menu_list": { events: ["delete_saved_place_list_dialog_opened"], elementType: "menu_list" },
    "edit_action_button": { events: ["saved_place_list_rename_form_opened"], elementType: "action_button" },
    "explore_action_button": { events: ["home_page_viewed"], elementType: "action_button" },
    "explore_nearby_action_button": { events: ["home_page_viewed"], elementType: "action_button" },
    "overflow_action_button": { events: ["saved_place_list_settings_menu_opened"], elementType: "action_button" },
    "page_view_page": { events: ["saved_place_list_viewed"], elementType: "page" },
    "place_card_card": { events: ["place_viewed"], elementType: "card" },
    "place_pin_target_area": { events: ["place_pin_selected"], elementType: "target_area" },
    "rename_menu_list": { events: ["saved_place_list_rename_form_opened"], elementType: "menu_list" },
    "save_place_action_button": { events: ["save_place_form_opened", "unsave_place_dialog_opened"], elementType: "action_button" },
    "search_place_input_field": { events: ["list_filtered"], elementType: "input_field" },
    "share_action_button": { events: ["saved_place_list_share_cta_activated"], elementType: "action_button" },
    "sort_dropdown_sort": { events: ["sort_changed"], elementType: "sort" },
    "view_toggle_chip": { events: ["saved_place_list_view_changed"], elementType: "chip" },
    "zoom_control_control_button": { events: ["map_zoomed"], elementType: "control_button" },
  },
  "saved_place_list_rename_form": {
    "close_action_button": { events: ["saved_place_list_rename_form_closed"], elementType: "action_button" },
    "page_view_page": { events: ["saved_place_list_rename_form_opened"], elementType: "page" },
    "save_action_button": { events: ["saved_place_list_renamed"], elementType: "action_button" },
  },
  "saved_places": {
    "cancel_action_button": { events: ["delete_saved_place_list_dialog_closed"], elementType: "action_button" },
    "close_action_button": { events: ["delete_saved_place_list_dialog_opened", "saved_place_list_settings_menu_closed"], elementType: "action_button" },
    "cover_photo_menu_list": { events: ["photo_source_menu_opened"], elementType: "menu_list" },
    "create_list_action_button": { events: ["create_saved_list_form_opened"], elementType: "action_button" },
    "delete_action_button": { events: ["saved_place_list_deleted"], elementType: "action_button" },
    "delete_menu_list": { events: ["delete_saved_place_list_dialog_opened"], elementType: "menu_list" },
    "overflow_action_button": { events: ["saved_place_list_settings_menu_opened"], elementType: "action_button" },
    "page_view_page": { events: ["saved_places_viewed"], elementType: "page" },
    "places_item_menu_list": { events: ["saved_places_viewed"], elementType: "menu_list" },
    "rename_menu_list": { events: ["saved_place_list_rename_form_opened"], elementType: "menu_list" },
    "saved_item_menu_list": { events: ["saved_searches_viewed"], elementType: "menu_list" },
    "saved_list_item_card": { events: ["saved_place_list_viewed"], elementType: "card" },
    "search_bar_input_field": { events: ["list_filtered"], elementType: "input_field" },
    "share_action_button": { events: ["saved_place_list_share_cta_activated"], elementType: "action_button" },
  },
  "saved_search_details": {
    "edit_action_button": { events: ["saved_search_edit_form_opened"], elementType: "action_button" },
    "page_view_page": { events: ["saved_search_details_viewed"], elementType: "page" },
    "search_action_button": { events: ["place_search_performed"], elementType: "action_button" },
  },
  "saved_search_edit": {
    "cancel_action_button": { events: ["delete_saved_search_dialog_closed"], elementType: "action_button" },
    "close_action_button": { events: ["saved_search_edit_form_closed"], elementType: "action_button" },
    "delete_action_button": { events: ["delete_saved_search_dialog_opened", "saved_search_removed"], elementType: "action_button" },
    "page_view_page": { events: ["saved_search_edit_form_opened"], elementType: "page" },
    "update_action_button": { events: ["saved_search_updated"], elementType: "action_button" },
  },
  "saved_searches": {
    "filter_input_input_field": { events: ["list_filtered"], elementType: "input_field" },
    "page_view_page": { events: ["saved_searches_viewed"], elementType: "page" },
    "saved_search_item_card": { events: ["saved_search_details_viewed"], elementType: "card" },
    "sort_dropdown_sort": { events: ["sort_changed"], elementType: "sort" },
  },
  "search": {
    "clear_action_button": { events: ["search_cleared"], elementType: "action_button" },
    "close_action_button": { events: ["search_list_closed"], elementType: "action_button" },
    "filter_input_field": { events: ["filter_opened"], elementType: "input_field" },
    "login_action_button": { events: ["auth_form_opened"], elementType: "action_button" },
    "manage_saved_search_link_button": { events: ["saved_searches_viewed"], elementType: "link_button" },
    "new_search_tab": { events: ["search_view_changed"], elementType: "tab" },
    "page_view_page": { events: ["search_page_viewed"], elementType: "page" },
    "saved_search_item_card": { events: ["saved_search_expanded"], elementType: "card" },
    "saved_search_tab": { events: ["search_view_changed"], elementType: "tab" },
    "search_bar_input_field": { events: ["search_list_viewed"], elementType: "input_field" },
    "search_submit_action_button": { events: ["place_search_performed"], elementType: "action_button" },
    "section_header_link_button": { events: ["neighborhood_viewed", "recent_searches_viewed"], elementType: "link_button" },
    "start_new_search_action_button": { events: ["search_view_changed"], elementType: "action_button" },
    "suggestion_item_card": { events: ["place_search_performed"], elementType: "card" },
  },
  "site_alerts": {
    "add_alert_action_button": { events: ["add_alert_form_opened"], elementType: "action_button" },
    "confirm_delete_action_button": { events: ["alert_deleted"], elementType: "action_button" },
    "edit_pencil_icon": { events: ["edit_alert_form_opened"], elementType: "icon" },
    "page_view_page": { events: ["site_alerts_viewed"], elementType: "page" },
    "place_name_link_link_button": { events: ["place_viewed"], elementType: "link_button" },
  },
  "space_accessibility_alerts": {
    "accessibility_alerts_banner_link_button": { events: ["accessibility_alerts_viewed"], elementType: "link_button" },
  },
  "space_action_menu": {
    "close_action_button": { events: ["space_action_menu_closed"], elementType: "action_button" },
    "page_view_page": { events: ["space_action_menu_opened"], elementType: "page" },
  },
  "space_add_info_menu": {
    "close_action_button": { events: ["space_add_info_menu_closed"], elementType: "action_button" },
    "page_view_page": { events: ["space_add_info_menu_opened"], elementType: "page" },
  },
  "support": {
    "book_call_link_button": { events: ["support_cta_activated"], elementType: "link_button" },
    "knowledge_base_link_button": { events: ["support_cta_activated"], elementType: "link_button" },
    "page_view_page": { events: ["support_page_viewed"], elementType: "page" },
    "send_email_link_button": { events: ["support_cta_activated"], elementType: "link_button" },
  },
  "tag_headers": {
    "page_view_page": { events: ["tag_header_viewed"], elementType: "page" },
  },
  "tag_space_details": {
    "add_information_action_button": { events: ["space_add_info_menu_opened"], elementType: "action_button" },
    "back_action_button": { events: ["tag_header_viewed"], elementType: "action_button" },
    "edit_space_action_button": { events: ["edit_space_form_opened"], elementType: "action_button" },
    "page_view_page": { events: ["tag_space_details_viewed"], elementType: "page" },
  },
  "tag_spaces": {
    "add_space_action_button": { events: ["add_space_form_opened"], elementType: "action_button" },
    "cancel_action_button": { events: ["clear_space_info_dialog_closed"], elementType: "action_button" },
    "clear_action_button": { events: ["clear_space_info_dialog_opened"], elementType: "action_button" },
    "confirm_action_button": { events: ["space_info_cleared"], elementType: "action_button" },
    "edit_information_link_button": { events: ["edit_tags_viewed"], elementType: "link_button" },
    "edit_pencil_action_button": { events: ["manage_photo_viewed"], elementType: "action_button" },
    "more_options_action_button": { events: ["space_action_menu_opened"], elementType: "action_button" },
    "page_view_page": { events: ["tag_header_viewed"], elementType: "page" },
    "photo_guide_link_button": { events: ["photo_guide_viewed"], elementType: "link_button" },
    "sort_dropdown_sort": { events: ["sort_changed"], elementType: "sort" },
    "space_card": { events: ["upload_photo_viewed"], elementType: "card" },
  },
  "team_create_form": {
    "close_action_button": { events: ["team_create_form_closed"], elementType: "action_button" },
    "create_action_button": { events: ["team_created"], elementType: "action_button" },
    "page_view_page": { events: ["team_create_form_opened"], elementType: "page" },
  },
  "team_invite_dialog": {
    "close_action_button": { events: ["team_invite_dialog_closed"], elementType: "action_button" },
    "join_team_action_button": { events: ["team_joined"], elementType: "action_button" },
    "page_view_page": { events: ["team_invite_dialog_opened"], elementType: "page" },
  },
  "team_landing": {
    "create_team_action_button": { events: ["team_create_form_opened"], elementType: "action_button" },
    "page_view_page": { events: ["team_landing_viewed"], elementType: "page" },
    "team_card_card": { events: ["team_viewed"], elementType: "card" },
  },
  "team_member_action_menu": {
    "close_action_button": { events: ["team_member_action_menu_closed"], elementType: "action_button" },
    "page_view_page": { events: ["team_member_action_menu_opened"], elementType: "page" },
    "remove_team_member_menu_list": { events: ["remove_team_member_dialog_opened"], elementType: "menu_list" },
    "view_profile_menu_list": { events: ["team_member_profile_viewed"], elementType: "menu_list" },
  },
  "team_page": {
    "about_team_action_button": { events: ["team_settings_menu_opened"], elementType: "action_button" },
    "cancel_action_button": { events: ["delete_team_dialog_closed", "leave_team_dialog_closed"], elementType: "action_button" },
    "change_cover_photo_action_button": { events: ["photo_source_menu_opened"], elementType: "action_button" },
    "close_action_button": { events: ["team_settings_menu_closed", "team_share_menu_closed"], elementType: "action_button" },
    "confirm_delete_action_button": { events: ["team_deleted"], elementType: "action_button" },
    "delete_team_action_button": { events: ["delete_team_dialog_opened"], elementType: "action_button" },
    "invite_team_action_button": { events: ["team_share_menu_opened"], elementType: "action_button" },
    "leave_action_button": { events: ["team_left"], elementType: "action_button" },
    "leave_team_action_button": { events: ["leave_team_dialog_opened"], elementType: "action_button" },
    "page_view_page": { events: ["team_viewed"], elementType: "page" },
    "rename_team_action_button": { events: ["team_rename_form_opened"], elementType: "action_button" },
    "send_invite_action_button": { events: ["team_share_cta_activated"], elementType: "action_button" },
    "share_link_action_button": { events: ["team_share_cta_activated"], elementType: "action_button" },
    "show_qr_code_action_button": { events: ["team_qr_code_opened"], elementType: "action_button" },
    "team_member_card": { events: ["team_member_profile_viewed"], elementType: "card" },
  },
  "team_qr_code": {
    "close_action_button": { events: ["team_qr_code_closed"], elementType: "action_button" },
    "page_view_page": { events: ["team_qr_code_opened"], elementType: "page" },
  },
  "team_rename_form": {
    "close_action_button": { events: ["team_rename_form_closed"], elementType: "action_button" },
    "page_view_page": { events: ["team_rename_form_opened"], elementType: "page" },
    "save_action_button": { events: ["team_renamed"], elementType: "action_button" },
  },
  "update_live_alerts": {
    "close_action_button": { events: ["update_live_alerts_closed"], elementType: "action_button" },
    "no_chip": { events: ["vote_alert_cta_activated"], elementType: "chip" },
    "not_sure_chip": { events: ["vote_alert_cta_activated"], elementType: "chip" },
    "page_view_page": { events: ["update_live_alerts_viewed"], elementType: "page" },
    "report_new_alert_action_button": { events: ["add_alert_form_opened"], elementType: "action_button" },
    "report_new_alert_link_button": { events: ["add_alert_form_opened", "alert_voted"], elementType: "link_button" },
    "yes_chip": { events: ["vote_alert_cta_activated"], elementType: "chip" },
  },
  "update_password_form": {
    "back_action_button": { events: ["update_password_form_closed"], elementType: "action_button" },
    "page_view_page": { events: ["update_password_form_opened"], elementType: "page" },
    "submit_password_action_button": { events: ["password_updated"], elementType: "action_button" },
  },
  "update_personal_details_form": {
    "close_action_button": { events: ["update_personal_details_form_closed"], elementType: "action_button" },
    "page_view_page": { events: ["update_personal_details_form_opened"], elementType: "page" },
    "save_changes_action_button": { events: ["personal_details_updated"], elementType: "action_button" },
  },
  "upload_photo": {
    "add_photo_action_button": { events: ["photo_source_menu_opened"], elementType: "action_button" },
    "from_photos_action_button": { events: ["photo_source_cta_activated"], elementType: "action_button" },
    "page_view_page": { events: ["upload_photo_viewed"], elementType: "page" },
    "photo_guide_link_button": { events: ["photo_guide_viewed"], elementType: "link_button" },
    "take_photo_action_button": { events: ["photo_source_cta_activated"], elementType: "action_button" },
  },
  "user_profile_action_menu": {
    "block_user_menu_list": { events: ["block_user_cta_activated"], elementType: "menu_list" },
    "close_action_button": { events: ["user_profile_action_menu_closed"], elementType: "action_button" },
    "flag_user_menu_list": { events: ["flag_user_cta_activated"], elementType: "menu_list" },
    "page_view_page": { events: ["user_profile_action_menu_opened"], elementType: "page" },
  },
  "verify_email": {
    "open_email_app_action_button": { events: ["email_app_cta_activated"], elementType: "action_button" },
    "page_view_page": { events: ["verify_email_viewed"], elementType: "page" },
    "return_to_login_action_button": { events: ["auth_form_opened"], elementType: "action_button" },
  },
  "widget_editor": {
    "close_action_button": { events: ["widget_editor_closed"], elementType: "action_button" },
    "copy_code_action_button": { events: ["widget_code_copy_cta_activated"], elementType: "action_button" },
    "page_view_page": { events: ["widget_editor_opened"], elementType: "page" },
    "save_action_button": { events: ["widget_added", "widget_edited"], elementType: "action_button" },
  },
  "widget_location": {
    "city_item_card": { events: ["widget_location_changed"], elementType: "card" },
    "close_control_button": { events: ["widget_change_location_list_closed", "widget_closed"], elementType: "control_button" },
    "location_label_action_button": { events: ["widget_change_location_list_viewed"], elementType: "action_button" },
    "page_view_page": { events: ["widget_loaded", "widget_location_viewed", "widget_opened"], elementType: "page" },
  },
} as const satisfies Record<
  string,
  Record<string, { events: readonly EventName[]; elementType: string }>
>;

export type PageEventsMap = typeof PAGE_EVENTS;
export type PageKey = keyof PageEventsMap;
